// const appConfig = {
//   API_URL: 'http://localhost:5009/api/v1',
//   SITE_URL: 'http://localhost:5173',
//   FILE_URL: 'http://localhost:5009/uploads/',
//   CONTACT_URL: 'http://localhost:8080',

//   // API_URL: 'https://backend.timelesspuglia.com/api/v1',
//   // SITE_URL:"https://app.timelesspuglia.com",
//   // FILE_URL: 'https://backend.timelesspuglia.com/uploads/',
//   // CONTACT_URL:"https://contract.timelesspuglia.com",
// };

// export default appConfig;
const appConfig = {
  API_URL: process.env.REACT_APP_API_URL,
  SITE_URL: process.env.REACT_APP_SITE_URL,
  FILE_URL: process.env.REACT_APP_FILE_URL,
  CONTACT_URL: process.env.REACT_APP_CONTACT_URL,
};

export default appConfig;
